import { render, staticRenderFns } from "./DocumentActions.vue?vue&type=template&id=4f53024d&scoped=true"
import script from "./DocumentActions.vue?vue&type=script&lang=js"
export * from "./DocumentActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53024d",
  null
  
)

export default component.exports